import { Box, IconButton } from "@mui/material";
import { Ico_Reply } from "@sagecentral/core-ui";
import { INote, NoteClickSignature } from "models/notes";
import NoteMenuButton from "./NoteMenuButton";

type NoteButtonGroupProps = {
    note: INote;
    allowReply?: boolean;
    onReplyClick: NoteClickSignature;
    onDeleteClick: NoteClickSignature;
    onEditClick: NoteClickSignature;
};

const NoteButtonGroup: React.FC<NoteButtonGroupProps> = (props) => {
    const {
        note, 
        allowReply,
        onReplyClick,
        onDeleteClick,
        onEditClick
    } = props;
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'end',
            padding: '8px'
        }}>
            { allowReply ?
            <IconButton onClick={() => onReplyClick(note)}>
                <Ico_Reply color='primary'/>
            </IconButton>
            : <></>
            }
            { note.isUserNote ?                    
            <NoteMenuButton note={note} 
                onDeleteClick={onDeleteClick} 
                onEditClick={onEditClick}
            />
            : <></>
            }
        </Box>
    );
};

export default NoteButtonGroup;